var path = '/common/formly/formly.tpl.html';
var html = "<thismoment-formly-form autocomplete=$ctrl.autocomplete cancel-background-color=$ctrl.cancelBackgroundColor cancel-color=$ctrl.cancelColor cancel-text=$ctrl.cancelText fields=$ctrl.fields form-data=$ctrl.formData options=$ctrl.options on-cancel=$ctrl.onCancel on-submit=$ctrl.onSubmit submit-background-color=$ctrl.submitBackgroundColor submit-color=$ctrl.submitColor submit-text=$ctrl.submitText></thismoment-formly-form> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/common/formly/formly.tpl.html
// module id = 213
// module chunks = 0 1 2 3 5 6